import { TopicPack } from "@/types";

const covid19: TopicPack = {
  id: "us-politics-vol-1",
  sku: "pack-us-politics-vol-1",
  name: "U.S. Politics Vol. I",
  topics: [
    [
      "American Healthcare System",
      "AOC",
      "Bernie Bros",
      "Brett Kavanaugh",
      "Build that Wall",
      "Don Trump Jr.",
      "Elizabeth Warren",
      "Email Servers",
      "Jared Kushner",
      "Joe Biden",
      "Kellyanne Conway",
      "Mayor Pete",
      "Medicare for All",
      "Mitch McConnell",
      "Okay, Boomer",
      "Pee Tapes",
      "Pizzagate",
      "Post-Truth",
      "Rush Limbaugh",
      "Ruth Bader Ginsburg",
      "Ted Cruz",
      "The Clintons",
      "The GOP",
      "The US Senate",
      "Trump Rallies",
      "Tucker Carlson",
      "Women's March",
    ],
  ],
};

export default covid19;
